import { useContext, useEffect, useState } from 'react'
import { DrawerWrapper } from './style'
import { toAbsoluteUrl } from '../../../utils/assetHelper'
import { useNavigate, useLocation } from 'react-router-dom';
import { Tooltip as ReactTooltip } from "react-tooltip";
import ReactPrint from "react-to-print";
import { AuthContext } from '../../../context/auth';
import { createCartApi, addItemsToCartApi, getCoaApi } from '../../../api'
import { getLocalStorage, setLocalStorage } from "../../../helpers/localStorage";
import { isVideoFile, getMp4Url, isGif } from '../../../utils/videoHelper'
import { isValidURL } from '../../../utils/urlHelper';
import { printPdf } from '../../../utils/print';
import { methodologyShortName } from '../../../utils/methodology';
import { crossReactivityMap } from '../../../utils/crossReactivity';
import { getNestedValue, productFields } from '../../../utils/productFields';
import { useMixPanel } from '../../../hooks/useMixPanel';
import { useGtag } from '../../../hooks/useGtag';

const Index = ({ previewProduct, setPreviewProduct, setSelectedProduct, coARef, setOpenItemPreviewModal, setModalName, setOpenMethodologyModal, isSlug }) => {
    const { setIsLoading, setCartData, isLoading, setTempDisable, tempDisable, setNotification } = useContext(AuthContext)
    const galleryUrl = `${process.env.REACT_APP_GALLERY_URL}150:150`
    const cartId = getLocalStorage('cartId')
    const location = useLocation()
    const navigate = useNavigate()
    const { mixPanelEvent, mixPanelServerEvent } = useMixPanel()
    const { gtagViewDownloadEvent, gtagAddToCart } = useGtag()
    const [productTab, setProductTab] = useState("primary")
    const [images, setImages] = useState([])
    const [imageSlideIndex, setImageSlideIndex] = useState(0)
    const { fromMethodology } = location.state || {}

    useEffect(() => {
        if (previewProduct?.mid_code.search("PA") >= 0) {
            setProductTab("primary")
        } else if (previewProduct?.mid_code.search("DC") >= 0) {
            setProductTab("alexaflour")
        } else {
            setProductTab("")
        }

        if (previewProduct?.metadata?.images) {
            const arr = previewProduct?.metadata?.images?.filter((item) => item.url !== '')
            const splitArr = Array.from({ length: Math.ceil(arr.length / 4) }, (_, index) =>
                arr.slice(index * 4, index * 4 + 4)
            );
            setImages(splitArr)
        }

    }, [previewProduct])

    const AddToCart = () => {
        setIsLoading(true)
        if (!cartId) {
            createCartApi().then(res => {
                setLocalStorage('cartId', res.data.cart.id)
                addItemsToCartApi(res.data.cart.id, {
                    variant_id: previewProduct?.variants[0]?.id,
                    quantity: 1,
                }).then((res) => {
                    if (res && res.data && res.data?.cart) {
                        setCartData(res.data.cart)
                        setNotification({
                            message: 'Added to cart',
                            type: 'green',
                        })
                        gtagAddToCart(res?.data?.cart?.subtotal, previewProduct)
                        setIsLoading(false)
                    } else {
                        setNotification({
                            message: 'Something went wrong',
                            type: 'red',
                        })
                        setIsLoading(false)
                    }
                })
            })
        } else {
            addItemsToCartApi(cartId, {
                variant_id: previewProduct?.variants[0]?.id,
                quantity: 1,
            }).then((res) => {
                if (res && res.data && res.data?.cart) {
                    setCartData(res.data.cart)
                    setNotification({
                        message: 'Added to cart',
                        type: 'green',
                    })
                    gtagAddToCart(res?.data?.cart?.subtotal, previewProduct)
                    setIsLoading(false)
                } else {
                    setNotification({
                        message: 'Something went wrong',
                        type: 'red',
                    })
                    setIsLoading(false)
                }
            })
        }
    }

    const BuyProduct = () => {
        setIsLoading(true)
        if (!cartId) {
            createCartApi().then(res => {
                setLocalStorage('cartId', res.data.cart.id)
                addItemsToCartApi(res.data.cart.id, {
                    variant_id: previewProduct?.variants[0]?.id,
                    quantity: 1,
                }).then((res) => {
                    if (res && res.data && res.data?.cart) {
                        setCartData(res.data.cart)
                        setNotification({
                            message: 'Added to cart',
                            type: 'green',
                        })
                        setIsLoading(false)
                        navigate('/checkout')
                    } else {
                        setNotification({
                            message: 'Something went wrong',
                            type: 'red',
                        })
                        setIsLoading(false)
                    }
                })
            })
        } else {
            addItemsToCartApi(cartId, {
                variant_id: previewProduct?.variants[0]?.id,
                quantity: 1,
            }).then((res) => {
                if (res && res.data && res.data?.cart) {
                    setCartData(res.data.cart)
                    setNotification({
                        message: 'Added to cart',
                        type: 'green',
                    })
                    setIsLoading(false)
                    navigate('/checkout')
                } else {
                    setNotification({
                        message: 'Something went wrong',
                        type: 'red',
                    })
                    setIsLoading(false)
                }
            })
        }
    }

    const openPrintDialog = (pdfUrl) => {
        window.open(pdfUrl, '_blank')
    }

    const printCoa = (id) => {
        setIsLoading(true)
        getCoaApi(id).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            setIsLoading(false)
            printPdf(url)
        }).catch(() => {
            setIsLoading(false)
        })
    }

    return (
        <>
            <DrawerWrapper>
                <div className="drawer-modal-content">
                    {productTab && <div className="header">
                        <h2>Anti-Human {previewProduct?.subtitle}</h2>
                        <div className="icons-container">
                            <i className='fal fa-times' onClick={() => {
                                setOpenItemPreviewModal(false)
                                setPreviewProduct(null)
                                if (fromMethodology) {
                                    navigate(`/product-search/${previewProduct?.handle}/${fromMethodology}`)
                                } else {
                                    navigate('/product-search')
                                }
                            }}></i>
                        </div>
                    </div>
                    }
                    {!productTab && <div className="header">
                        <h2>{previewProduct?.host} {previewProduct?.species_reactivity}</h2>
                        <div className="icons-container">
                            <i className='fas fa-times' onClick={() => {
                                setOpenItemPreviewModal(false)
                                setPreviewProduct(null)
                                if (fromMethodology) {
                                    navigate(`/product-search/${previewProduct?.handle}/${fromMethodology}`)
                                } else {
                                    navigate('/product-search')
                                }
                            }}></i>
                        </div>
                    </div>
                    }
                    {productTab && <div className="tab-container">
                        <button style={{ borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', width: '35%' }} className={productTab === "primary" && 'tab-active'} disabled >Primary Antibodies</button>
                        <button style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px', width: '65%' }} className={productTab === "alexaflour" && 'tab-active'} disabled>Identifyn® SRM AlexaFluor™ Conjugates</button>
                    </div>
                    }
                    {productTab === 'alexaflour' && <button className='dye-btn' disabled >Dye: {previewProduct?.dyes}</button>}
                    {productTab && <div className="items-container">
                        <button style={{ borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' }} className={previewProduct?.host + " " + previewProduct?.clonality === "Mouse Monoclonal" && 'tab-active'} disabled >Mouse Monoclonal</button>
                        <button style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }} className={previewProduct?.host + " " + previewProduct?.clonality === "Mouse Recombinant Monoclonal" && 'tab-active'} disabled>Mouse Recombinant Monoclonal</button>
                        <button style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }} className={previewProduct?.host + " " + previewProduct?.clonality === "Rabbit Polyclonal" && 'tab-active'} disabled>Rabbit Polyclonal</button>
                        <button style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }} className={previewProduct?.host + " " + previewProduct?.clonality === "Rabbit Recombinant Monoclonal" && 'tab-active'} disabled>Rabbit Recombinant Monoclonal</button>
                        <button style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }} className={previewProduct?.host + " " + previewProduct?.clonality === "Rat Monoclonal" && 'tab-active'} disabled>Rat Monoclonal</button>
                    </div>
                    }
                    <div className="item-details-container">
                        <div style={{ width: '100%' }}>
                            <div className="item-detail-header">
                                <div className="left-container" style={{ width: '85%' }}>
                                    <h4 style={{ color: 'var(--primary-color)' }}>{previewProduct?.title}{productTab && `, ${previewProduct?.metadata?.subclass}`}{previewProduct?.metadata?.cloneId && ` - (${previewProduct?.metadata?.cloneId})`}</h4>
                                    <h5>Cat ID# - {previewProduct?.mid_code} {previewProduct?.material}</h5>
                                </div>
                                <div>
                                    {/* <ReactPrint
                                onBeforeGetContent={() => {
                                    setIsLoading(true)
                                }}
                                onAfterPrint={() => {
                                    setIsLoading(false)
                                }}
                                trigger={() => <span className='coa' style={{cursor:'pointer', alignSelf:'flex-start'}}>
                                    CoA</span>}
                                content={() => coARef.current}
                            /> */}
                                    {previewProduct?.metadata?.coa && <span className='coa' style={{ cursor: 'pointer' }} onClick={() => {
                                        openPrintDialog(previewProduct?.metadata?.coa?.url)
                                        const data = {
                                            product_id: previewProduct?.id,
                                            cat_id: `${previewProduct?.mid_code} ${previewProduct?.material}`,
                                            product_name: previewProduct?.title,
                                            file_url: previewProduct?.metadata?.coa?.url
                                        }
                                        mixPanelEvent('COA', data)
                                        mixPanelServerEvent('COA', data)
                                        gtagViewDownloadEvent('coa', data)
                                    }}>
                                        CoA
                                    </span>
                                    }
                                    {previewProduct?.metadata?.sds && <span className='coa' style={{ cursor: 'pointer', marginTop: '5px' }} onClick={() => {
                                        openPrintDialog(previewProduct?.metadata?.sds?.url)
                                        const data = {
                                            product_id: previewProduct?.id,
                                            cat_id: `${previewProduct?.mid_code} ${previewProduct?.material}`,
                                            product_name: previewProduct?.title,
                                            file_url: previewProduct?.metadata?.sds?.url
                                        }
                                        mixPanelEvent('SDS', data)
                                        mixPanelServerEvent('SDS', data)
                                        gtagViewDownloadEvent('sds', data)
                                    }}>
                                        SDS
                                    </span>
                                    }
                                </div>
                            </div>
                            {
                                crossReactivityMap?.find((item) =>
                                    (item.host === previewProduct?.host && item.species_reactivity === previewProduct?.species_reactivity))
                                &&
                                (
                                    < h5 className='cross_reactivity'>
                                        {previewProduct?.mid_code === "SA" ? "Cross Absorption" : "Cross Reactivity"}:{' '}
                                        {
                                            crossReactivityMap?.find((item) =>
                                                (item.host === previewProduct?.host && item.species_reactivity === previewProduct?.species_reactivity)
                                            )?.cross_reactivity
                                        }
                                    </h5>
                                )
                            }
                        </div>
                        <div className='item-content-container'>
                            {productFields.map((field, index) => {
                                const shouldShow = !field.condition || field.condition(productTab, previewProduct);
                                if (!shouldShow) return null;

                                const rawValue = field.valueKey
                                    ? getNestedValue(previewProduct, field.valueKey)
                                    : undefined;

                                const formattedValue = field.format
                                    ? field.format(field.valueKey ? rawValue : previewProduct)
                                    : rawValue ?? '-';

                                const isLink = field.linkPrefix && rawValue;
                                const linkHref = isLink ? `${field.linkPrefix}${rawValue}${field.linkSuffix || ''}` : null;

                                return (
                                    <div className="item-content" key={index}>
                                        <div className="left-container">
                                            <h4 style={{ width: 'max-content' }}>{field.label}</h4>
                                        </div>
                                        <div className="right-container">
                                            <h4 className={isLink ? 'external_link' : ''}>
                                                {isLink ? (
                                                    <a href={linkHref} target="_blank" rel="noopener noreferrer">
                                                        {rawValue}
                                                    </a>
                                                ) : (
                                                    formattedValue || '-'
                                                )}
                                            </h4>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="item-content">
                            <div className="left-container" style={{ width: '50%' }}>
                                <h4>Applications</h4>
                            </div>
                            <div className="right-container">
                                <div className="application-container">
                                    {previewProduct?.metadata?.protein_application?.map((item) => {
                                        return <span style={{ cursor: 'default' }}
                                            onClick={() => {
                                                setSelectedProduct({
                                                    title: previewProduct?.title,
                                                    id: previewProduct?.id,
                                                    handle: previewProduct?.handle,
                                                    metadata: {
                                                        images: previewProduct?.metadata?.images.map((image) => {
                                                            return {
                                                                ...image,
                                                                product_id: previewProduct?.id,
                                                                product_handle: previewProduct?.handle,
                                                                product_name: previewProduct?.title
                                                            }
                                                        })
                                                    }
                                                })
                                                setModalName(item.name)
                                                setOpenItemPreviewModal(false)
                                                if (isSlug) {
                                                    navigate(`/product-search/${previewProduct?.handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === item.name) || item.name}`)
                                                    setOpenMethodologyModal(true)
                                                }
                                            }}
                                            data-tooltip-id="applications" data-tooltip-content={item.name}>{item.abbr}</span>
                                    })
                                    }
                                    {previewProduct?.metadata?.microscopy_application?.map((item) => {
                                        return <span style={{ cursor: 'default' }}
                                            onClick={() => {
                                                setSelectedProduct({
                                                    title: previewProduct?.title,
                                                    id: previewProduct?.id,
                                                    handle: previewProduct?.handle,
                                                    metadata: {
                                                        images: previewProduct?.metadata?.images.map((image) => {
                                                            return {
                                                                ...image,
                                                                product_id: previewProduct?.id,
                                                                product_handle: previewProduct?.handle,
                                                                product_name: previewProduct?.title
                                                            }
                                                        })
                                                    }
                                                })
                                                setModalName(item.abbr === 'STORM' ? 'Super Resolution - Single Molecule STORM' : item.name)
                                                setOpenItemPreviewModal(false)
                                                if (isSlug) {
                                                    navigate(`/product-search/${previewProduct?.handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === item.abbr === 'STORM' ? 'Super Resolution - Single Molecule STORM' : item.name) || item.name}`)
                                                    setOpenMethodologyModal(true)
                                                }
                                            }}
                                            data-tooltip-id="applications" data-tooltip-content={item.name}>{item.abbr}</span>
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="item-content">
                            <div className="left-container">
                                <h4>Price / 50 µL Unit Size</h4>
                            </div>
                            <div className="right-container">
                                <h4>${(previewProduct?.variants[0]?.prices[0]?.amount / 100)?.toFixed(2)}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="item-image-container">
                        {images && images.length > 0 && <div className="images-container">
                            {images[imageSlideIndex]?.map((item, index) => {
                                return <div className="image" onClick={() => {
                                    setSelectedProduct({
                                        title: previewProduct?.title,
                                        id: previewProduct?.id,
                                        handle: previewProduct?.handle,
                                        metadata: {
                                            images: previewProduct?.metadata?.images.map((image) => {
                                                return {
                                                    ...image,
                                                    product_id: previewProduct?.id,
                                                    product_handle: previewProduct?.handle,
                                                    product_name: previewProduct?.title
                                                }
                                            })
                                        }
                                    })
                                    setModalName(item.name)
                                    setOpenItemPreviewModal(false)
                                    if (isSlug) {
                                        navigate(`/product-search/${previewProduct?.handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === item.name) || item.name}`)
                                        setOpenMethodologyModal(true)
                                    }
                                }} key={index}>
                                    {isVideoFile(item) ?
                                        <video src={getMp4Url(item.url)} muted loop autoPlay playsInline /> :
                                        isGif(item) ?
                                            <img src={item.url} alt="" /> :
                                            <img src={galleryUrl + `:${item.url?.split('.com/')[1]}` || toAbsoluteUrl('/media/methodologyplaceholder.png')} alt="" />
                                    }
                                    <h6>{item.name}</h6>
                                </div>
                            })}
                        </div>
                            // :
                            // <div className='no-orders'>
                            //     <span className='icon'>
                            //         <i class="far fa-images"></i>
                            //     </span>
                            //     <p>No Images Available.</p>
                            // </div>
                        }
                        {images && images.length > 1 && <div className="buttons-container">
                            <button onClick={() => {
                                if (imageSlideIndex > 0) {
                                    setImageSlideIndex(imageSlideIndex - 1)
                                } else {
                                    setImageSlideIndex(0)
                                }
                            }}><i className='fas fa-chevron-left'></i></button>
                            <div className="dots">
                                {
                                    images.map((item, index) => {
                                        return <span className={imageSlideIndex === index ? "active-dot" : ""} key={index}></span>
                                    })
                                }
                                {/* <span className='active-dot'></span>
                                <span></span>
                                <span></span> */}
                            </div>
                            <button
                                onClick={() => {
                                    if (imageSlideIndex < images.length - 1) {
                                        setImageSlideIndex(imageSlideIndex + 1)
                                    } else {
                                        setImageSlideIndex(images.length - 1)
                                    }
                                }}
                            ><i className='fas fa-chevron-right'></i></button>
                        </div>
                        }
                    </div>
                    {previewProduct?.metadata?.reference && previewProduct?.metadata?.reference?.some((item) => isValidURL(item)) &&
                        <div className='references-container'>
                            <h4>References</h4>
                            {
                                previewProduct?.metadata?.reference?.map((item, index) => {
                                    if (isValidURL(item)) {
                                        return <a href={item.includes("https") ? item : `https://${item}`} target="_blank" key={index}>{item}</a>
                                    }
                                })}
                        </div>
                    }
                    <p className='exclusive-container'>
                        Get Identifyn® products exclusively through <img src={toAbsoluteUrl('/media/logoicon.png')} />
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <a href={previewProduct?.metadata?.thermofisher_link} target="_blank"
                            onClick={() => {
                                const data = {
                                    product_id: previewProduct?.id,
                                    cat_id: `${previewProduct?.mid_code} ${previewProduct?.material}`,
                                    product_name: previewProduct?.title,
                                    thermo_link: previewProduct?.metadata?.thermofisher_link
                                }
                                mixPanelEvent('thermo', data)
                                mixPanelServerEvent('thermo', data)
                                gtagViewDownloadEvent('thermo', data)
                            }}
                        ><img src={toAbsoluteUrl("/media/thermologo.png")} alt="thermologo" width={'148px'} height={'70px'} /></a>
                    </div>
                    <p style={{ padding: '12px 10px', background: '#FFF2E5', borderRadius: '12px', color: '#DC4405', fontWeight: 700, textAlign: 'center', fontSize: '16px', lineHeight: '24px' }}>Identifyn® Super Resolution Vetted
                    Premium Research Products are Available through our Preferred Industry Partners
                    </p>
                    {!previewProduct?.metadata?.thermofisher_link && 
                    <div className="add-cart-container">
                        <button className='btn add-btn'
                            disabled={isLoading}
                            onClick={() => {
                                AddToCart()
                            }}
                        >
                            <i className='fal fa-shopping-cart'></i>
                            Add to Cart</button>
                        <button className='btn buy-btn'
                            disabled={isLoading}
                            onClick={() => {
                                BuyProduct()
                            }}
                        >Buy Now</button>
                    </div>
                    }
                </div>
                <ReactTooltip
                    id="applications"
                    place="top"
                    variant="light"
                />
            </DrawerWrapper>
        </>
    )
}

export default Index